"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadlineColor = exports.HeadlineAlign = exports.HeadlineStyle = void 0;
var HeadlineStyle;
(function (HeadlineStyle) {
    HeadlineStyle["Display"] = "display";
    HeadlineStyle["Hero"] = "hero";
    HeadlineStyle["Huge"] = "huge";
    HeadlineStyle["Big"] = "big";
    HeadlineStyle["Large"] = "large";
    HeadlineStyle["MediumLarge"] = "medium-large";
    HeadlineStyle["Medium"] = "medium";
})(HeadlineStyle = exports.HeadlineStyle || (exports.HeadlineStyle = {}));
var HeadlineAlign;
(function (HeadlineAlign) {
    HeadlineAlign["Left"] = "left";
    HeadlineAlign["Center"] = "center";
    HeadlineAlign["Right"] = "right";
})(HeadlineAlign = exports.HeadlineAlign || (exports.HeadlineAlign = {}));
var HeadlineColor;
(function (HeadlineColor) {
    HeadlineColor["ThemePrimary"] = "theme-primary";
    HeadlineColor["DigitalBlack"] = "digital-black";
    HeadlineColor["White"] = "white";
})(HeadlineColor = exports.HeadlineColor || (exports.HeadlineColor = {}));
//# sourceMappingURL=Headline.types.js.map